import React from "react";
import { useState, useEffect } from "react";
import { i18n, classNames } from "@euroland/libs";
import { PickerDate } from "@euroland/calendar-react";

function QuadrataSingleRangePickerDate({
  onChange,
  minDate,
  maxDate,
  dateFormat,
  textCancel = "",
  textApply = "",
  isRtl,
  value
}) {
  const [{ from, to }, setState] = useState({
    from: value.from,
    to: value.to,
  });
  // TODO:
  // const minStartingDateInstrument = useSelector(minStartingDateInstrumentSelector);

  useEffect(() => {
    onChange?.({ from, to });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // minDate and maxDate of date picker
  // const minDate = minStartingDateInstrument ? new Date(minStartingDateInstrument) : null;
  // const maxDate = new Date();

  return (
    <div className="SingleRangePickerDate">
      <div className="startDate">
        <label className="screen-reader-only startDateLabel" htmlFor="startDateRange">
          {i18n.translate("startDate")}
        </label>
        <PickerDate
          value={from}
          minDate={minDate}
          maxDate={to}
          onChange={from => {
            onChange({ from, to });
            setState(prev => ({ ...prev, from }));
          }}
          className={classNames({
            left: !isRtl,
            right: isRtl,
          })}
          dateFormat={dateFormat}
          textCancel={textCancel}
          textApply={textApply}
          id="startDateRange"
        />
      </div>
      <div className="endDate">
        <label className="screen-reader-only endDateLabel" htmlFor="endDateRange">
          {i18n.translate("endDate")}
        </label>
        <PickerDate
          minDate={from}
          maxDate={maxDate}
          value={to}
          onChange={to => {
            onChange({ from, to });
            setState(prev => ({ ...prev, to }));
          }}
          className={classNames({
            left: !isRtl,
            right: isRtl,
          })}
          dateFormat={dateFormat}
          textCancel={textCancel}
          textApply={textApply}
          id="endDateRange"
        />
      </div>
    </div>
  );
}

export default React.memo(QuadrataSingleRangePickerDate);
